import platformBridgeFactory from '@researchmetrics/platform-bridge-factory'
import appWrapperWebImplementation from './app-wrapper-web-implementation.js'

const appWrapperBridgeAPI = {
  //openSurvey: function() {}
  openInBrowser: function() {}
}

platformBridgeFactory.create(
  appWrapperBridgeAPI,
  'AppWrapperBridgeAPI',
  appWrapperWebImplementation
)

export default appWrapperBridgeAPI
